// PaymentModal.js
import React, { useEffect, useState } from 'react';
import './PaymentModal.css';
// import payU from '../../images/payu.webp'
// import razorpay from '../../images/razorpay.png'
// import BHIM from "../../images/bhim.png"
// import payU from '../../images/payu-logo.png'
import razorpay from '../../assets/rozypay1-logo.png'
// import Instify from "../../images/instifi-logo.png"
// import cashfree from "../../images/cashfree.png";
// import Pageload from './Pageload';
// import Upi from '../../images/upi.png'
// import { Button } from 'bootstrap/dist/js/bootstrap.bundle.min';

const PaymentModal = ({ onClose,onRazorpay, isLoading, pgData }) => {
  // let paymentGateways = [];
  // if (pgData) {
  //   pgData.map((pg) => {
  //     paymentGateways.push(pg.mpg_gateway_name);
  //   });
  // }

  // const [showOthers, setShowOthers] = useState(false);

  return (
    <>
      {/* {isLoading ? (
        <div className="modal-overlay">
          <div className="modal-content" style={{ textAlign: 'center', padding: '20px', height: '300px' }}>
            <h3>Processing Payment</h3>
            <Pageload />
          </div>
        </div>
      ) : ( */}
        <div className="modal-overlay">

          <div className="modal-content">


            <h3>Choose Payment Method</h3>

            <div className="modal-actions">
              {/* {showOthers && (
                <>

                 
                  {paymentGateways && paymentGateways.includes("Payu") ?
                    <img
                      src={payU}
                      alt="Pay with Razorpay"
                      className="pay-image"
                      onClick={onPayU}
                      style={{ cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.5 : 1 }}
                    />
                    : ''}

                     {paymentGateways && paymentGateways.includes("Razorpay") ? */}
                    <img
                      src={razorpay}
                      alt="Pay with PayU"
                      className="pay-image"
                      onClick={onRazorpay}
                      style={{ cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.5 : 1 }}
                    />
                    {/* : ''}
                </>
              )} */}
              {/* {pgData[0]?.mpg_company_id == 1 ?
                <img
                  src={Instify}
                  alt="Pay with instify"
                  className="pay-image"
                  onClick={onInstify}
                  style={{ cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.5 : 1 }}
                />
                : ''} */}

              {/* {paymentGateways && paymentGateways.includes("ICICI UPI") ?
          <img 
            src={Upi} 
            alt="Pay with upi" 
            className="pay-image" 
            onClick={onUpi} 
            style={{cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.5 : 1 }} 
          />
          :''}  */}
              {/* {paymentGateways && paymentGateways.includes("Cashfree") ?
          <img
              src={cashfree}
              alt="Pay with Cashfree"
              className="pay-image"
              onClick={onCashFree}
              style={{  cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.5 : 1 }}
            />:''} */}

            </div>



            <button
              className="cancel-button"
              onClick={onClose}
            >
              X
            </button>
            {/* {!showOthers && (
              <button
                className="fw-semibold fs-5 mt-3 ms-bnt btn btn-primary"
                onClick={() => setShowOthers(true)}
              >
                Show other payment options
              </button>
            )} */}


          </div>


        </div>
      {/* )} */}
    </>


  );
};

export default PaymentModal;
